import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const ContactPage = () => {
  useEffect(() => {
    document.title = 'İletişim | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İzmir vize danışmanlığı için bizimle iletişime geçin. Karşıyaka ofisimizden veya WhatsApp, telefon ile 7/24 ulaşabilirsiniz. Tuna Mah. Kemalpaşa Cad. Karşıyaka/İzmir');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-12 md:py-20 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
              backgroundSize: '40px 40px'
            }}></div>
          </div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <span className="inline-block px-3 py-1.5 md:px-4 md:py-2 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              İletişim
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              Bizimle İletişime Geçin
            </h1>
            <p className="text-cream-200 text-base md:text-xl max-w-3xl mx-auto leading-relaxed">
              İzmir vize danışmanlığı hizmetlerimiz hakkında bilgi almak için bize ulaşın
            </p>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-16">
              <div className="bg-cream-50 rounded-xl md:rounded-2xl p-6 md:p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-navy-900 rounded-xl md:rounded-2xl mx-auto mb-4 md:mb-6">
                  <i className="ri-phone-fill text-2xl md:text-3xl text-cream-400"></i>
                </div>
                <h3 className="font-display text-base md:text-xl font-bold text-navy-900 mb-2 md:mb-3">Telefon</h3>
                <a href="tel:+905514803007" className="text-navy-600 hover:text-navy-900 transition-colors text-sm md:text-lg cursor-pointer">
                  +90 551 480 3007
                </a>
                <p className="text-navy-500 text-xs md:text-sm mt-2">Pazartesi - Cuma: 09:00 - 18:00</p>
              </div>

              <div className="bg-cream-50 rounded-xl md:rounded-2xl p-6 md:p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-navy-900 rounded-xl md:rounded-2xl mx-auto mb-4 md:mb-6">
                  <i className="ri-mail-fill text-2xl md:text-3xl text-cream-400"></i>
                </div>
                <h3 className="font-display text-base md:text-xl font-bold text-navy-900 mb-2 md:mb-3">E-posta</h3>
                <a href="mailto:karsiyakavisaconsulting@gmail.com" className="text-navy-600 hover:text-navy-900 transition-colors text-xs md:text-sm cursor-pointer break-all">
                  karsiyakavisaconsulting@gmail.com
                </a>
                <p className="text-navy-500 text-xs md:text-sm mt-2">7/24 Destek</p>
              </div>

              <div className="bg-cream-50 rounded-xl md:rounded-2xl p-6 md:p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-navy-900 rounded-xl md:rounded-2xl mx-auto mb-4 md:mb-6">
                  <i className="ri-map-pin-fill text-2xl md:text-3xl text-cream-400"></i>
                </div>
                <h3 className="font-display text-base md:text-xl font-bold text-navy-900 mb-2 md:mb-3">Adres</h3>
                <p className="text-navy-600 text-xs md:text-sm leading-relaxed">
                  Tuna Mah. Kemalpaşa Cad.<br />
                  Kat:5/506 Ses İş Hanı<br />
                  Karşıyaka / İzmir
                </p>
              </div>
            </div>

            {/* Map */}
            <div>
              <h2 className="font-display text-2xl md:text-3xl font-bold text-navy-900 mb-4 md:mb-6 text-center">
                Ofis Konumumuz
              </h2>
              <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-xl h-[400px] md:h-[600px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3124.4567890123456!2d27.09833!3d38.46111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b963e6c8a8c8c8%3A0x1234567890abcdef!2sTuna%2C%20Kemalpa%C5%9Fa%20Cd.%2C%2035530%20Kar%C5%9F%C4%B1yaka%2F%C4%B0zmir!5e0!3m2!1str!2str!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Karşıyaka Visa Consulting Ofis Konumu"
                ></iframe>
                
                {/* Overlay Card */}
                <div className="absolute bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-6 bg-white rounded-lg md:rounded-xl p-4 md:p-6 shadow-2xl">
                  <h3 className="font-display text-base md:text-xl font-bold text-navy-900 mb-2 md:mb-3">
                    Karşıyaka Visa Consulting
                  </h3>
                  <div className="space-y-2">
                    <div className="flex items-start space-x-2 md:space-x-3">
                      <i className="ri-map-pin-fill text-navy-900 mt-1 text-sm md:text-base"></i>
                      <p className="text-navy-700 text-xs md:text-sm">
                        Tuna Mah. Kemalpaşa Cad. Kat:5/506<br />
                        Ses İş Hanı Karşıyaka / İzmir
                      </p>
                    </div>
                    <a
                      href="https://www.google.com/maps/dir//Tuna,+Kemalpaşa+Cd.,+35530+Karşıyaka/İzmir"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-navy-900 font-semibold text-xs md:text-sm hover:text-navy-700 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Yol Tarifi Al
                      <i className="ri-arrow-right-line ml-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Quick Contact Section */}
        <section className="py-12 md:py-20 bg-navy-900">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              Hızlı İletişim
            </h2>
            <p className="text-cream-200 text-sm md:text-lg mb-6 md:mb-10">
              İzmir vize danışmanlığı için anında destek almak isterseniz
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-4 md:space-x-6">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-semibold text-base md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2 md:mr-3"></i>
                WhatsApp ile Yaz
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-semibold text-base md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default ContactPage;